import React from 'react';

/** Admin-only "Mine / Everyone" switch for owner-scoped lists (documents, media creations). */
const OwnerScopeToggle = ({ viewer, scope, onChange, disabled = false }) => {
  if (!viewer?.is_admin) return null;
  const option = (value, label) => (
    <button
      type="button"
      role="radio"
      aria-checked={scope === value}
      className={`dd-scope-option ${scope === value ? 'active' : ''}`}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (scope !== value) onChange(value);
      }}
    >
      {label}
    </button>
  );
  return (
    <div className="dd-scope-toggle" role="radiogroup" aria-label="Show items from">
      {option('mine', 'Mine')}
      {option('all', 'Everyone')}
    </div>
  );
};

export const ownerLabel = (row) => row?.owner_name || row?.owner_upn || row?.created_by || 'Unassigned';

export default OwnerScopeToggle;
